import ogImageAsset from "../assets/og-image.jpg.asset.json";

export const SITE_URL = "https://vendingmachinefree.com";
export const OG_IMAGE_URL = `${SITE_URL}${ogImageAsset.url}`;

/** Returns the meta entries for og:image + twitter:image. */
export function ogImageMeta() {
  return [
    { property: "og:image", content: OG_IMAGE_URL },
    { property: "og:image:alt", content: "Vending Machine Free.com — Free vending machines nationwide USA" },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:type", content: "image/jpeg" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:image", content: OG_IMAGE_URL },
  ];
}
